import {Payload} from 'common/src/modules/api/apiTypes';
import {Secret} from 'common/src/modules/secrets/secrets.types';

const fetchSecretByKeyPromises: Partial<Record<Secret, Promise<Payload<string>>>> = {};

export {fetchSecretByKeyPromises};
